import { createAsyncThunk } from "@reduxjs/toolkit";
// import { store } from "./store";
import logTypes from "./features/logTypes";
import axios from "axios";
import { openFeedBack } from "./features/examDetails/examDetailsSlice";
import { logout } from "./features/authVerification/authSlice";
import xss from "xss";

export const startExamActivity = createAsyncThunk(
  "exam/startActivity",
  async ({ examId, candidateId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/exams/${examId}/candidate/${candidateId}/start`,
        {
          clearanceInfo: true,
        }
      );
      return { ...response.data };
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data.message);
      } else {
        return rejectWithValue("Network Error.");
      }
    }
  }
);

export const updateExamActivities = createAsyncThunk(
  "exam/updateActivity",
  async (_, { rejectWithValue, getState }) => {
    //details._id
    const {
      questions: { list },
      examDetail: { activity },
    } = getState();
    const attemptedArray = list
      .filter((x) => x.answer?.length && x.type === "multichoice")
      .map((x) => ({
        questionId: x._id,
        selected: x.answer.map((ans) => x.options[ans]),
      }));
    try {
      const response = await axios.put(
        `/examactivities/${activity._id}/update`,
        {
          attemptedQuestions: attemptedArray,
        }
      );
      return { ...response.data };
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data.message);
      } else {
        return rejectWithValue("Network Error.");
      }
    }
  }
);

export const submitTheory = createAsyncThunk(
  "exam/submitTheory",
  async (answeredIndex, { rejectWithValue, getState }) => {
    //details._id
    const {
      questions: { list },
      examDetail: { activity },
    } = getState();
    if (list[answeredIndex].type !== "theory") {
      return;
    }
    const theoryQuestion = list[answeredIndex];

    const questionAnswer = xss(theoryQuestion.answer, {
      whiteList: {},
      stripIgnoreTag: true,
      stripIgnoreTagBody: ["script"],
    }).trim();
    if (!questionAnswer) {
      return;
    }
    try {
      const response = await axios.put(
        `/examactivities/${activity._id}/update/theory/${theoryQuestion._id}`,
        {
          answer: theoryQuestion.answer,
        }
      );
      return { ...response.data };
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data.message);
      } else {
        return rejectWithValue("Network Error.");
      }
    }
  }
);

export const submitExam = createAsyncThunk(
  "exam/submit",
  async (_, { rejectWithValue, getState, dispatch }) => {
    //details._id
    const {
      questions: { list },
      examDetail: { activity },
    } = getState();
    const attemptedMultiChoice = list
      .filter((x) => x.type === "multichoice")
      .map((x) => ({
        questionId: x._id,
        selected: x.answer ? x.answer.map((ans) => x.options[ans]) : [],
      }));
    const attemptedTheory = list
      .filter((x) => x.type === "theory")
      .map((x) => ({
        questionId: x._id,
        answer: x.answer ?? null,
      }));
    try {
      const response = await axios.put(
        `/examactivities/${activity._id}/submit`,
        {
          multichoiceQuestions: attemptedMultiChoice,
          theoryQuestions: attemptedTheory,
        }
      );
      console.log(response);
      if (response) {
        const feedBackInterval = setTimeout(() => {
          dispatch(openFeedBack());
          clearTimeout(feedBackInterval);
        }, 3000);
        const logoutInterval = setTimeout(() => {
          dispatch(logout());
          clearTimeout(logoutInterval);
        }, 1000);
      }

      return { ...response.data };
    } catch (err) {
      dispatch(submitExam());
      if (err.response) {
        return rejectWithValue(err.response.data.message);
      } else {
        return rejectWithValue("Network Error.");
      }
    }
  }
);

// let audioLog = {
//   id: uuidv4(),
//   logType,
//   saved: false,
//   time: Date.now() - startTime,
//   dataUrl: window.URL.createObjectURL(dataBlob),
// };

export const exitFullscreenFlag = createAsyncThunk(
  "exam/exitFullscreenFlag",
  async (punishment, { rejectWithValue, getState, dispatch }) => {
    //details._id
    const {
      examDetail: { activity },
      timer: {
        times: { startTime },
      },
    } = getState();
    try {
      let log = {
        description: "Candidate exited full screen",
        title: "Exited Full screen",
        time: Date.now() - startTime,
      };
      const response = await axios.post(
        `/flag/${activity._id}/exitfullscreen`,
        log
      );
      if (response && punishment === "suspendExam") {
        dispatch(submitExam());
      }
      return { ...response.data };
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data.message);
      } else {
        return rejectWithValue("Network Error.");
      }
    }
  }
);

export const submitFlags = createAsyncThunk(
  "exam/flags",
  async ({ id, logType, dataUrl, time }, { rejectWithValue, getState }) => {
    //details._id
    const {
      examDetail: { activity },
      auth: { userData },
    } = getState();
    try {
      let dataBlob = await fetch(dataUrl).then((r) => r.blob());
      dataBlob.lastModifiedDate = new Date();
      dataBlob.name = `${logType.toLowerCase()}.${
        logType === logTypes.SOUND_DETECTED ? "ogg" : ".png"
      }`;
      console.log(dataBlob.name);
      console.log(dataBlob);
      let flagData = new FormData();

      flagData.append("title", logType);
      flagData.append("time", time);
      if (logType === logTypes.PERIODIC_SNAPSHOT) {
        flagData.append("imageUrl", userData.imageUrl);
        flagData.append("photo", dataBlob);
        const response = await axios.post(`/facial/${activity._id}`, flagData);
        return { ...response.data };
      } else {
        flagData.append("mediaFile", dataBlob);
        const response = await axios.post(`/flag/${activity._id}`, flagData);
        return { ...response.data, id, logType };
      }
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data.message);
      } else {
        return rejectWithValue("Network Error.");
      }
    }
  }
);

export const routineCheckSave = createAsyncThunk(
  "exam/routineCheckSave",
  async (_, { getState, dispatch }) => {
    //details._id
    const {
      audio: { audioLog },
      snapshot: { snapshotLog },
    } = getState();

    const fetchUnSaved = [
      ...Object.values(audioLog).filter(({ saved }) => !saved),
      ...Object.values(snapshotLog).filter(({ saved }) => !saved),
    ];
    console.info(fetchUnSaved);

    for (let index = 0; index < fetchUnSaved.length; index++) {
      const flags = fetchUnSaved[index];
      dispatch(submitFlags(flags));
    }
  }
);
